import { cookieConfig } from '@/configs/cookie.config';
import { cookieHelper } from '@/helpers/cookie.helper';
import { useAuthStore } from '@/stores/auth.store';
import type { UserCredentials } from '@/types/user';
import { storeToRefs } from 'pinia';
import type { RouteLocation } from 'vue-router';
import http from "../utils/http-common";
import router from "@/router";

type ResponseUser = {
    id: string;
    email: string;
    name: string;
    status: number;
};

const getUserInfo = async () => {
    try {
        return http.get<ResponseUser>('/user/me');
    } catch (error) {
        console.error('Error user/me:', error);
    }
};

const getUserLocal = (): UserCredentials | null => {
    const userSaved = cookieHelper.get(cookieConfig.user.name);
    if (userSaved) {
        try {
            const parseInfo = JSON.parse(userSaved);
            if (parseInfo.token) {
                return parseInfo as UserCredentials;
            }
        } catch (error) {
            console.error('Error parsing user data from cookie:', error);
        }
    }
    return null;
};

export const authGuard = async (to: RouteLocation) => {
    const authStore = useAuthStore();
    const { isLoggedIn } = storeToRefs(authStore);

    // If not logged in, try to restore session from cookie
    if (!isLoggedIn.value) {
        const userSaved = getUserLocal();
        if (userSaved) {
            try {
                // Set the token first so the API call can use it
                authStore.setAllToken(userSaved);
                const res = await getUserInfo();
                if (res?.data) {
                    authStore.login(res.data);
                }
            } catch (error) {
                console.error('Error restoring session:', error);
                authStore.logout();
            }
        }
    }

    // Handle route guards
    // if (!to.meta.requiresAuth) {
    //     return;
    // }

    if (!isLoggedIn.value && to.meta.requiresAuth) {
        return { name: 'LoginSignUp' };
    }

    if (isLoggedIn.value && to.name === 'LoginSignUp') {
        return router.push('/dashboard')
        // return { name: 'home' };
    }
};
